export const APP_NAME = import.meta.env.VITE_AUTH_APP_NAME || 'Cogknit.io';
export const WEBSITE_DOMAIN =
  import.meta.env.VITE_AUTH_WEBSITE_DOMAIN || 'http://localhost:3000/hinal';
export const API_BASE_PATH =
  import.meta.env.VITE_AUTH_API_BASE_PATH || '/api/auth';
export const WEBSITE_BASE_PATH = '/auth';
export const USERBACK_TOKEN = import.meta.env.VITE_USERBACK_TOKEN;
